/**
 * Feature toggle to enable OwF grants program.
 */
export const OWF_GRANTS_241003 = 'OWF_GRANTS_241003';
